// @flow
import React from 'react'

const AccessDenied = () => {
  return (
    <div className='login'>
      <div className='login__header'>
        <i className='icon icon--logo' />
        <h3>Access Denied</h3>
      </div>
      <h4>You do not have the necessary permissions to access this application. Please contact <a href='mailto:support@lanetix.com'>support@lanetix.com</a> if you believe this is an error or if you need access to this application</h4>
    </div>
  )
}

export default AccessDenied
